
import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseComponent from '@/author/components/BaseComponent.vue';

@Component
export default class FinalSlide extends BaseComponent {
  @Prop() enableScrollIndication!: boolean;
  @Prop() title!: string;
  @Prop() subtitle?: string;
  @Prop() backgroundImage?: string;
  @Prop() theme?: string;
  @Prop({ default: 'center' }) align?: string;
  @Prop({ default: 'full' }) layout?: string;
  @Prop({ default: 0 }) padding?: string;
  @Prop({ default: 'normal' }) size?: string;
  @Prop(String) hiddenTitle!: string;
  closeSuccess: boolean = true;

  get canClose() {
    return this.closeSuccess;
  }

  onClickClose(): void {
    this.closeSuccess = window.close() !== undefined;
    this.closeNav();
  }
}
